import { render } from "./NodeForm.vue?vue&type=template&id=50facb8d&scoped=true"
import script from "./NodeForm.vue?vue&type=script&lang=js"
export * from "./NodeForm.vue?vue&type=script&lang=js"

import "./NodeForm.vue?vue&type=style&index=0&id=50facb8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50facb8d"]])

export default __exports__